import '../filter_view.js.coffee'

Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.CountryFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'countries'
  facetName: 'country'
  selectAll: true

  getAppliedValues: () ->
    return @searchQuery.get('countries')

  addFilter: (value) ->
    @searchQuery.addCountry(value)
